import { render } from "./DocumentList.vue?vue&type=template&id=653793d8&scoped=true"
import script from "./DocumentList.vue?vue&type=script&lang=js"
export * from "./DocumentList.vue?vue&type=script&lang=js"

import "./DocumentList.vue?vue&type=style&index=0&id=653793d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653793d8"]])

export default __exports__